<div
    class="preview-wrapper"
    [@openClose]="(isPreview$ | async) ? 'open' : 'closed'"
    (@openClose.done)="animationEvent($event)"
>
    <div
        [class.preview-tablet]="isPreviewTablet$ | async"
        [class.preview-mobile]="isPreviewMobile$ | async"
        style="height: 100%"
    >
        <iframe [srcdoc]="html" width="100%" height="100%" frameBorder="0" class="preview-frame"></iframe>
    </div>
</div>
